import React from 'react'

import { ActionIcon, Badge } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'
import IconAdd from 'src/icons/IconAdd'
import IconChevronDown from 'src/icons/IconChevronDown'
import IconEdit from 'src/icons/IconEdit'

interface ApplicationCardHeaderProps {
  title: string
  titleExtra?: React.ReactNode
  canAdd?: boolean
  editing?: boolean
  setEditing?: any
  handleAdd?: any
  readonly?: boolean
  isEmpty?: boolean
  opened?: boolean
  setOpened?: any
}

const ApplicationCardHeader = ({
  title,
  titleExtra,
  canAdd = true,
  isEmpty = false,
  readonly = false,
  opened = false,
  setOpened,
  editing,
  setEditing,
  handleAdd,
}: ApplicationCardHeaderProps) => {
  return (
    <div
      className="text-md flex w-full cursor-pointer flex-row items-center gap-2 font-semibold text-doubleNickel-gray-900"
      onClick={() => setOpened((prev) => !prev)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          setOpened((prev) => !prev)
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={opened}
    >
      <ActionIcon variant="subtle" className="pointer-events-none">
        <IconChevronDown
          className={`h-4 w-4 ${
            !opened && '-rotate-90'
          } fill-none stroke-doubleNickel-gray-500 transition-all`}
        />
      </ActionIcon>
      {title}
      {isEmpty && (
        <Badge variant="light" className="rounded" color="blue">
          No data
        </Badge>
      )}
      {/* Right-aligned action area: header extras (e.g. count pill) sit just
          left of the Edit / Add control. */}
      <div className="ml-auto flex items-center gap-2">
        {titleExtra}
        {!readonly && (
          <>
            {!editing ? (
              isEmpty && canAdd ? (
                <ActionIcon
                  className="h-8 w-8 border border-doubleNickel-gray-200 bg-doubleNickel-white shadow-sm hover:bg-doubleNickel-gray-200"
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!opened) setOpened(true)
                    setEditing(true)
                    handleAdd()
                  }}
                >
                  <IconAdd className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
                </ActionIcon>
              ) : (
                <DNButton
                  variant="transparent"
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!opened) setOpened(true)
                    setEditing(true)
                  }}
                  className="text-doubleNickel-gray-700"
                >
                  <IconEdit className="h-3.5 w-3.5 fill-none stroke-current" />
                  Edit
                </DNButton>
              )
            ) : (
              canAdd && (
                <ActionIcon
                  className="h-8 w-8 border border-doubleNickel-gray-200 bg-doubleNickel-white shadow-sm hover:bg-doubleNickel-gray-200"
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!opened) setOpened(true)
                    handleAdd()
                  }}
                >
                  <IconAdd className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
                </ActionIcon>
              )
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ApplicationCardHeader
